module.exports = __webpack_public_path__ + "static/t4-4c23ec11eeb0d0ba470a073529fe7bad.png";